import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'

export default function SearchResultList(props) {
  const {list, searchTerm, clickHandler} = props
  return (
    <ul className="searchResult" data-testid="searchResult">
      {renderResults(list, searchTerm, clickHandler).every(x => x === null) ? (
        <li className="item secondary" data-testid="noResultError">
          <span>{i18n.t('course_module_not_found')}</span>
        </li>
      ) : (
        renderResults(list, searchTerm, clickHandler)
      )}
    </ul>
  )
}

function renderResults(list, searchTerm, clickHandler) {
  return list.map((item, index) => {
    if (checkIfListItemContainsSearchTerm(item, searchTerm)) {
      return (
        <li key={index.toString()} className="item" data-testid="searchResultItem">
          <span role="button" tabIndex={index} onClick={clickHandler} onKeyDown={clickHandler}>
            {item}
          </span>
        </li>
      )
    }
    return null
  })
}

function checkIfListItemContainsSearchTerm(item, searchTerm) {
  return item.toLowerCase().includes(searchTerm.toLowerCase())
}

SearchResultList.propTypes = {
  list: PropTypes.array,
  searchTerm: PropTypes.string,
  clickHandler: PropTypes.func,
}
